import { FC } from 'react';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '~/assets';
import { observer } from '~/modules';
import If from '../If';
import PersonInfo from '../PersonInfo';
import {
  AccountStatus,
  AccountStatusIcon,
  AccountStatusText,
  Column,
  IconStyled,
  InfoItem,
  InfoList,
  Label,
  LabelBox,
  Value,
  Wrapper,
} from './styles';

type Props = {
  clientName?: string;
  isClientAppAccessBlocked?: boolean;
  clientDetailedInfo: { label: string; value: string; icon: IconDefinition }[];
};

const UserInfoCard: FC<Props> = ({
  clientName,
  clientDetailedInfo,
  isClientAppAccessBlocked,
}) => {
  return (
    <Wrapper>
      <Column>
        <PersonInfo name={clientName} />
        <If condition={!!isClientAppAccessBlocked}>
          <AccountStatus>
            <AccountStatusIcon icon={faInfoCircle} />
            <AccountStatusText>Acesso ao app bloqueado</AccountStatusText>
          </AccountStatus>
        </If>
      </Column>

      <Column>
        <InfoList>
          {clientDetailedInfo.map((info) => (
            <InfoItem>
              <IconStyled icon={info.icon} />
              <LabelBox>
                <Label>{info.label}</Label>
                <Value>{info.value}</Value>
              </LabelBox>
            </InfoItem>
          ))}
        </InfoList>
      </Column>
    </Wrapper>
  );
};

export default observer(UserInfoCard);
